const directive = {
  mounted(el) {
    el.focus();
  }
};
export {
  directive as default,
  directive
};
